export default __webpack_public_path__ + "static/media/logo.380c6381.png";